import { lazy, Suspense } from "react";
import { useStorePanel } from "@hooks/useStorePanel";
import BootScreen from "@routes/BootScreen";
import PanelApp from "./PanelApp";
const StoreRoutes = lazy(() => import("./StoreRoutes"));

export function App() {
  const { isStorePanel } = useStorePanel();

  // The order page address carries the order token, so no third-party script may run there.
  return isStorePanel ? (
    <Suspense fallback={<BootScreen />}>
      <StoreRoutes />
    </Suspense>
  ) : (
    <PanelApp />
  );
}

export default App;
